import { render, staticRenderFns } from "./SupplierTaxProfile.vue?vue&type=template&id=488d710e&"
import script from "./SupplierTaxProfile.vue?vue&type=script&lang=js&"
export * from "./SupplierTaxProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports